<template lang="pug">
#modal-vincular-camadas-em-lote
    el-dialog(
        width='80%',
        title='Selecione as empresas e camadas',
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        main
            .modal-vincular-camadas-em-lote__camadas
                h3.mb-3
                    | Camadas
                    BaseButton(
                        v-if='acao === "VINCULAR"',
                        size='mini',
                        icon='el-icon-check',
                        @click='selecionarConfiguracaoVega'
                    ) Configuração Vega

                el-card(shadow='never', :body-style='{ padding: "10px" }')
                    el-table.box-card(
                        ref='tabelaCamadas',
                        :data='camadasFiltradas',
                        size='mini',
                        height='350px',
                        @selection-change='alterarCamadasSelecionadas'
                    )
                        el-table-column(type='selection', width='50')
                        el-table-column(
                            label='Nome',
                            prop='nome',
                            sortable,
                            :min-width='100'
                        )
                        el-table-column(align='right')
                            template(slot='header', slot-scope='scope')
                                el-input(
                                    v-model='filtroCamadas',
                                    size='mini',
                                    placeholder='Pesquisar'
                                )

                    footer.mt-2
                        span {{ camadasSelecionadas.length }} {{ camadasSelecionadas.length === 1 ? 'camada selecionada' : 'camadas selecionadas' }}

            .modal-vincular-camadas-em-lote__empresas
                h3.mb-3 Empresas
                el-card(shadow='never', :body-style='{ padding: "10px" }')
                    el-table.box-card(
                        ref='tabelaEmpresas',
                        :data='empresasFiltradas',
                        size='mini',
                        height='350px',
                        @selection-change='alterarEmpresasSelecionadas'
                    )
                        el-table-column(type='selection', width='50')
                        el-table-column(
                            label='Nome',
                            prop='name',
                            sortable,
                            :min-width='100'
                        )
                        el-table-column(align='right')
                            template(slot='header', slot-scope='scope')
                                el-input(
                                    v-model='filtroEmpresas',
                                    size='mini',
                                    placeholder='Pesquisar'
                                )

                    footer.mt-2
                        span {{ empresasSelecionadas.length }} {{ empresasSelecionadas.length === 1 ? 'empresa selecionada' : 'empresas selecionadas' }}

        footer(slot='footer')
            BaseButton(size='mini', @click='fechar') Cancelar
            BaseButton(size='mini', type='primary', @click='executarAcao') {{ acao === 'VINCULAR' ? 'Vincular' : 'Remover' }}
</template>

<script>
import { CamadasService } from '@/services/CamadasService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalVincularCamadasEmLote',

    components: {
        BaseButton
    },

    props: {
        mostrar: {
            type: Boolean,
            required: true
        },
        empresas: {
            type: Array,
            required: true
        },
        camadas: {
            type: Array,
            required: true
        },
        acao: {
            type: String, // VINCULAR | REMOVER
            required: true
        }
    },

    data() {
        return {
            filtroEmpresas: '',
            filtroCamadas: '',
            empresasSelecionadas: [],
            camadasSelecionadas: []
        };
    },

    computed: {
        empresasFiltradas() {
            return this.empresas.filter(empresa =>
                empresa.name
                    .toLowerCase()
                    .includes(this.filtroEmpresas.toLowerCase())
            );
        },

        camadasFiltradas() {
            return this.camadas.filter(camada =>
                camada.nome
                    .toLowerCase()
                    .includes(this.filtroCamadas.toLowerCase())
            );
        }
    },

    methods: {
        fechar() {
            this.filtroEmpresas = '';
            this.filtroCamadas = '';
            this.empresasSelecionadas = [];
            this.camadasSelecionadas = [];

            this.$refs.tabelaEmpresas.clearSelection();
            this.$refs.tabelaCamadas.clearSelection();

            this.$emit('fechar');
        },

        alterarEmpresasSelecionadas(linhas) {
            this.empresasSelecionadas = linhas;
        },

        alterarCamadasSelecionadas(linhas) {
            this.camadasSelecionadas = linhas;
        },

        selecionarConfiguracaoVega() {
            CamadasService.buscarCamadasVega()
                .then(({ data }) => {
                    const camadasVega = data;
            
                    this.camadasSelecionadas = this.camadas.filter(({ codigo }) =>
                        camadasVega.includes(codigo)
                    );

                    this.camadasSelecionadas.forEach(camada =>
                        this.$refs.tabelaCamadas.toggleRowSelection(camada)
                    );
            })
            .catch(() => {
                this.$notify.error({
                    message: `Ocorreu um erro ao buscar a configuração vega.`
                });
            });
        },

        executarAcao() {
            if (this.acao === 'VINCULAR') this.vincularCamadas();
            else this.removerCamadas();
        },

        async vincularCamadas() {
            const idsEmpresas = this.empresasSelecionadas.map(({ id }) => id);
            const idsCamadas = this.camadasSelecionadas.map(({ id }) => id);

            try {
                await CamadasService.vincularCamadasEmpresas(
                    idsEmpresas,
                    idsCamadas
                );

                this.$emit('atualizar-tabela');
                this.$notify.success({ message: 'Camadas vinculadas' });
                this.fechar();
            } catch (e) {
                this.$notify.error({
                    message:
                        'Ocorreu um erro ao vincular as camadas as empresas'
                });
            }
        },

        async removerCamadas() {
            const idsEmpresas = this.empresasSelecionadas.map(({ id }) => id);
            const idsCamadas = this.camadasSelecionadas.map(({ id }) => id);

            try {
                await CamadasService.removerCamadasEmpresas(
                    idsEmpresas,
                    idsCamadas
                );

                this.$emit('atualizar-tabela');
                this.$notify.success({ message: 'Camadas vinculadas' });
                this.fechar();
            } catch (e) {
                this.$notify.error({
                    message:
                        'Ocorreu um erro ao remover vinculo de camadas com empresas'
                });
            }
        }
    }
};
</script>
<style lang="scss">
#modal-vincular-camadas-em-lote {
    main {
        display: flex;
        justify-content: center;
        gap: 16px;

        footer {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }

    footer {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
    }

    .modal-vincular-camadas-em-lote__empresas,
    .modal-vincular-camadas-em-lote__camadas {
        width: 45%;

        h3 {
            display: flex;
            font-size: 16px;
            justify-content: space-between;
            align-items: center;
            height: 28px;
        }
    }
}
</style>
